var render = function render(){var _vm=this,_c=_vm._self._c;return _c('alert-resource-list',{attrs:{"id":_vm.id,"list-id":_vm.id,"get-params":_vm.mergedGetParams,"hidden-columns":_vm.hiddenColumns}})
}
var staticRenderFns = []

export { render, staticRenderFns }